"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImportMetadata = void 0;
var path_1 = require("./utils/path");
function getImportMetadata(args) {
    var path = (0, path_1.removeFinalSlash)(args.path);
    var alias = (0, path_1.removeFinalSlash)(args.alias);
    var url = args.url;
    var replaced = url.replace(alias, path);
    var directory = replaced.slice(0, replaced.lastIndexOf('/'));
    var file = replaced.slice(replaced.lastIndexOf('/') + 1);
    var extension = file.includes('.') ? file.slice(file.lastIndexOf('.') + 1, file.length) : '';
    var filename = file.includes('.') ? file.slice(0, file.lastIndexOf('.')) : file;
    return {
        replaced: replaced,
        alias: alias,
        path: path,
        url: url,
        extension: extension,
        file: file,
        filename: filename,
        directory: directory,
    };
}
exports.getImportMetadata = getImportMetadata;
